import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/queryKeys'
import { usePermissions } from '@/shared/auth/usePermissions'
import { fetchOrgTree } from '@/features/org/orgApi'
import { useCashBranches } from '@/features/cashdesk/useCashBranches'

export function useBranchOptions(): { value: string; label: string }[] {
  const { can } = usePermissions()
  const cash = useCashBranches()
  const readTree = can('org.node.read')
  const tree = useQuery({
    queryKey: queryKeys.org.tree,
    queryFn: ({ signal }) => fetchOrgTree(signal),
    enabled: readTree,
  })
  if (readTree) {
    return (tree.data?.nodes ?? [])
      .filter((node) => node.state !== 'CLOSED')
      .map((node) => ({ value: node.id, label: `${node.displayName} (${node.code})` }))
  }
  return cash.all.map((branch) => ({ value: branch.id, label: `${branch.name} (${branch.code})` }))
}
